import { render, staticRenderFns } from "./CheckListSummary.vue?vue&type=template&id=0638e148&"
import script from "./CheckListSummary.vue?vue&type=script&lang=js&"
export * from "./CheckListSummary.vue?vue&type=script&lang=js&"
import style0 from "./CheckListSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports